import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';



export const cyolistStore = defineStore('cyolist', {

  state: () => {
    return {
      // setting, diamond
      skeleton:false,
      page:null,
      // ringm, earring, pendant
      moduleType: null, 
      moduleSubType: null, 
      filters : null,
      options: null,
      payload:null,
      filterTags:[],
      compare_list:[],
      compare_list_count:0,
      results:{
          data: Array.from({ length: 20 }, (v, i) => ({ id: 'empty_key_'+ i, key: 'empty_state' })),
          total:null,
          next_page_url:null,
          current_page:null,
      },
      error:null,
      showMoreSkeleton: false,
      currentController:null
    }
  },
  // could also be defined as
  // state: () => ({ count: 0 })
  getters: { ...getters},
  actions: {...actions, commitMutation: function( mutationToCall, data ) {

    try {
      mutations[mutationToCall]( this, data )
      
    } catch (error) {

      console.error( 'CYO LIST MUTATION ERROR - ', this, mutationToCall, data, error )
      throw error
    }

  }},
  // persist: true,
})

































// import { defineStore } from 'pinia'
// import useMutations from './mutations.js'
// import useActions from './actions.js'
// import useGetter from './getters.js'
// import {useState} from './state.js'

// import { ref, reactive } from 'vue'
// // import actions from './actions.js'


// export const cyolistStore = defineStore('cyolist', () =>  {
  
//     const state = useState()
//     const getters = useGetter(state)

//     const mutations = useMutations( )
//     const actions = useActions(state, getters, mutations)
    
//     // function setupCyoSettingFilter( { moduleType, moduleSubType, filters, page } ){

//     //   console.log( 'setupCyoSettingFilter -           --- ', moduleSubType )
//     //   stateValues.moduleType.value = moduleType
//     //   stateValues.moduleSubType.value = moduleSubType
//     //   stateValues.filters.value = filters
//     //   stateValues.page.value = page
//     // }


//     return { ...state, ...actions }


//     // state.filters             = data.filters
// 		// state.moduleType	      = data.moduleType
//     //     state.moduleSubType       = data.moduleSubType
// 		// state.page	              = data.page

//     // vuexContext.commit('setCyoSettingFilter', data);



//     // this.commit( 'setSettingListingResults', { clearListing: true, response: { data : [], total : 0, next_page_url: null } } )
    
//     // const res = await cyoApiListService(this).getMinMax( data )
    

//     // // set filter options
//     // await vuexContext.commit('setCyoSettingFilterOptions', res);

//     // await vuexContext.dispatch('setupCyoSettingFilterFromUrl');

//     // await vuexContext.dispatch('setRequestPayload', { unsetStartWith : false });
    

//     // // validate in case of create your own, exclude incase of loose 
//     // if ( data.moduleType === 'cyo' && data.page === 'setting' ) {

//     //     await vuexContext.dispatch('validateCyoSettingCase', data);
//     // }

//     // if ( data.moduleType === 'cyo' && data.page === 'diamond' ) {

//     //     await vuexContext.dispatch('validateCyoDiamondCase', data);
//     // }

//     // await vuexContext.dispatch( 'requestServer', { clearListing : true } )




















































//     return { }





















//     const temp = reactive({a: 10})

//     const valA = ref(0)

//     // const doubleCount = () =>  computed(() => (a,b) => {

//     //   console.log('a', 'b', a,b)
//     //   return 'abcd'
//     // } )

//     // const doubleCount = ( a, b ) => computed( () => {a, b } )
//     const doubleCount = computed( () =>{

//       console.log( 'acd', valA.value)
//       return ( ) =>  16 * valA.value;

//     })

//     const reactiveCoount = computed( () =>{

//       console.log( 'acd', stateValues.page.value, valA.value)
//       return ( ) =>  2 * valA.value;

//     })

//     // function updateValue(){

//     //   if( import.meta.server){

//     //     return
//     //   }

//     //   console.log('this', valA.value)
//     //    setInterval(() =>  {

//     //     valA.value++ 
//     //     temp.a++

//     //     console.log( 'set interval', valA.value)
//     //   } , 1000);
//     //   return

//     // }

//     // console.log('state', state)

//     // const doubleCount = computed( () => ( a,b  ) =>  {a,b}  )

//     // const t = state.page

//     // const doubleCount = temp;



//     // console.log( ' state -------------', state)








//     return { doubleCount ,temp, reactiveCoount }







//   // state: () => ({
//   //   skeleton: false,
//   //   page: null,
//   //   moduleType: null,
//   //   moduleSubType: null,
//   //   filters: null,
//   //   options: null,
//   //   payload: null,
//   //   compare_list: [],
//   //   compare_list_count: 0,
//   //   results: {
//   //     data: [],
//   //     total: null,
//   //     next_page_url: null,
//   //     current_page: null,
//   //   },
//   //   error: null,
//   //   showMoreSkeleton: false
//   // }),
//   // getters: {
//   //   // ...getters
//   // },
//   // actions: {
//   //   // ...actions,
//   //   // ...mutations
//   // }
// })
